export default __webpack_public_path__ + "static/media/Background_00128.55476900.png";